export class AssetNodeTransformer {
  static transform(obj) {
    let asset = {};
    asset.id = obj.id;
    asset.assetId = obj.attributes.asset_id;
    asset.latitude = obj.attributes.latitude;
    asset.longitude = obj.attributes.longitude;
    return asset;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/assetNodes/assetNode.transformer.js